import {
  getQuoteIdFromSession,
  removeQuoteIdFromSession,
  setQuoteIdToSession,
} from '../../utils/quoteId';
import safeFetch from '../../utils/safeFetch';

const getQuoteIdFromUrl = (getQuoteIdUrl) => {
  const quoteIdFromSession = getQuoteIdFromSession();
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      createQuoteIfNotExist: quoteIdFromSession ? '0' : '1',
      _: Date.now().toString(),
    });
    safeFetch(`${getQuoteIdUrl}?${params.toString()}`, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((quoteId) => {
        if (!quoteId) {
          reject({
            message: `No response after call getQuoteIdFromUrl (${getQuoteIdUrl})`,
          });
        } else {
          if (quoteId === '') {
            removeQuoteIdFromSession();
            getQuoteIdFromUrl(getQuoteIdUrl)
              .then((responseData) => resolve(responseData))
              .catch((error) => reject(error));
          } else if (quoteId && typeof quoteId === 'string') {
            if (!quoteIdFromSession || quoteIdFromSession !== quoteId) {
              setQuoteIdToSession(quoteId);
            }

            resolve(quoteId);
          } else if (!quoteId || typeof quoteId !== 'string') {
            reject(`Could not get quoteId or response is not a quoteId string: ${quoteId}`);
          }
        }
      })
      .catch((error) =>
        reject({
          message: `Response after call getQuoteIdFromUrl (${getQuoteIdUrl}) failed: ${error}`,
        }),
      );
  });
};

export default getQuoteIdFromUrl;
